import { AuditOutlined, HomeOutlined, WalletOutlined } from '@ant-design/icons';
import { Button } from 'antd';
import cn from 'classnames';
import type { TComponent } from 'utils/types/component';

import type { TabType } from 'components/domains/BalanceTableRedesign/components/MerchantCard';

import styles from './TabButton.module.scss';

interface ITabButtonProps {
    isActive: boolean;
    label: string;
    type: TabType;
    onClick: () => void;
}

const ICON_MAP = {
    common: HomeOutlined,
    deposits: WalletOutlined,
    payouts: AuditOutlined,
};

export const TabButton: TComponent<ITabButtonProps> = ({
    type,
    isActive,
    onClick,
    label,
}) => {
    const Icon = ICON_MAP[type];

    return (
        <Button
            type={isActive ? 'primary' : 'default'}
            className={cn(styles.tabButton, {
                'custom-tab-button': !isActive,
            })}
            icon={<Icon />}
            onClick={onClick}
        >
            {label}
        </Button>
    );
};
